var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoGluten(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31,25.31c2.9,2.9,3.4,7.11,2.11,8.4s-5.26.55-8.16-2.35-3.75-6.75-2.35-8.16S28.06,22.41,31,25.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.25,29.9c.28,4.32-1.94,8.32-3.65,8.67s-4.08-2.73-4.36-7.06,1.47-8.24,3.33-8.61S44,25.57,44.25,29.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.87,38.52c.28,4.32-1.93,8.32-3.64,8.67s-4.09-2.73-4.37-7.06,1.47-8.24,3.33-8.61S52.58,34.19,52.87,38.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.56,47.21c.29,4.33-1.93,8.33-3.64,8.67s-4.08-2.73-4.37-7.06,1.47-8.23,3.33-8.61S61.27,42.88,61.56,47.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.83,56.48c.28,4.32-1.93,8.33-3.64,8.67s-4.08-2.73-4.37-7.06,1.47-8.24,3.33-8.61C67.86,49.13,70.54,52.15,70.83,56.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.44,44.7c4.33.29,8.33-1.93,8.68-3.64S35.38,37,31.06,36.69,22.82,38.16,22.45,40C22.1,41.73,25.12,44.41,29.44,44.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.06,53.32c4.33.29,8.33-1.93,8.68-3.64S44,45.6,39.68,45.31s-8.24,1.47-8.61,3.33S33.74,53,38.06,53.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.76,62c4.32.29,8.33-1.93,8.67-3.64S52.7,54.29,48.37,54s-8.24,1.48-8.61,3.33S42.43,61.73,46.76,62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56,71.28c4.33.29,8.33-1.93,8.68-3.64S62,63.56,57.64,63.27,49.4,64.74,49,66.6,51.7,71,56,71.28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.91,
    y: 66.12,
    width: 4.71,
    height: 12.31,
    rx: 2.12,
    transform: "translate(-29.94 72.27) rotate(-45)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.82,18.18A45,45,0,0,0,18.18,81.82,45,45,0,0,0,81.82,18.18ZM50,9.06A40.77,40.77,0,0,1,77.19,19.43L19.43,77.19A40.91,40.91,0,0,1,50,9.06Zm0,81.88a40.77,40.77,0,0,1-27.34-10.5L80.44,22.66A40.91,40.91,0,0,1,50,90.94Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGluten);
export default __webpack_public_path__ + "static/media/no-gluten.9e26905ddae4d98397b6c45b54297a5f.svg";
export { ForwardRef as ReactComponent };